import { MyWorkPage } from '@/pages/crm/views/MyWorkPage';
import { createFileRoute } from '@tanstack/react-router';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/crm/my-work/')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({
			context,
			anyOf: ['leads.read.own', 'leads.read.all', 'deals.read.own', 'deals.read.all'],
			redirectTo: '/dashboard',
		}),
	component: MyWorkPage,
});
